// Firebase client — Auth + Firestore (for user-owned data: price alerts, location).
// Category/search data has moved to Supabase. Firestore here is only for
// features directly tied to Firebase Auth (price alerts, user preferences).
import { getApps, initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';

import { firebaseConfig } from '@/shared/src/config/firebase-config';

let firebaseApp: FirebaseApp | null = null;
let authInstance: Auth | null = null;
let firestoreInstance: Firestore | null = null;

function getFirebaseApp(): FirebaseApp {
  if (!firebaseApp) {
    firebaseApp = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
  }
  return firebaseApp;
}

export const app = new Proxy({} as FirebaseApp, {
  get(_target, prop) {
    return (getFirebaseApp() as any)[prop];
  },
});

export function getAuthInstance(): Auth {
  if (!authInstance) {
    authInstance = getAuth(getFirebaseApp());
  }
  return authInstance;
}

export const auth = new Proxy({} as Auth, {
  get(_target, prop) {
    return (getAuthInstance() as any)[prop];
  },
});

/** Firestore client — only for user-owned data (price alerts, location) tied to Firebase Auth. */
export function getFirestoreInstance(): Firestore {
  if (!firestoreInstance) {
    firestoreInstance = getFirestore(getFirebaseApp());
  }
  return firestoreInstance;
}

/** @deprecated Use Supabase for category/search data. Only for Auth-linked user data. */
export const db = new Proxy({} as Firestore, {
  get(_target, prop) {
    return (getFirestoreInstance() as any)[prop];
  },
});
